/** Einzelne Aktivität: Kopf, Kennzahlen, Markierungen, Zonen, Bewertung, Verlauf, Runden. */
export default {
  notLoaded: 'Aktivität nicht geladen: {error}',
  toList: 'zur Liste',
  loading: 'Lädt …',
  back: 'Aktivitäten',
  backAria: 'Zurück zu Aktivitäten',
  editAria: 'Titel und Notiz bearbeiten',
  kpis: 'Kennzahlen',
  kpi: {
    distance: 'Distanz',
    time: 'Zeit',
    speed: 'Tempo',
    pace: 'Pace',
    hr: 'Ø HF',
    elevation: 'Höhe',
    load: 'Last',
    hrTssEstimated: 'hrTSS geschätzt',
    power: 'Ø Leistung',
    energy: 'Energie',
    total: 'Gesamt mit Pausen',
    rpe: 'Anstrengung',
    rpeTip: 'Gefühlte Anstrengung (RPE) auf der Skala 1–10',
  },
  source: 'Quelle: {source}',
  fitOriginal: ' · FIT original',
  zonesTip: 'Zonen-Version {n}, Grenzen {floors} bpm',
  zonesChip: 'Zonen v{n} · gültig ab {date}',
  download: 'FIT herunterladen',
  noFit: 'Für diese Fassung liegt keine FIT-Datei im Archiv',
  replacedKept: ' · die verdrängte Fassung bleibt im Archiv',
  fitFrom: 'FIT von {source}',
  route: 'Route',
  mapNote: 'Startort nur für dich sichtbar · in Karten ausgeblendet',
  media: {
    aria: 'Fotos und Videos',
    title: 'Fotos',
    add: 'Foto hinzufügen',
    uploading: 'Lädt hoch …',
    failed: 'Nicht hochgeladen: {error}',
    heic: 'HEIC kann dieser Browser nicht umwandeln – bitte als JPEG exportieren.',
    tooBig: 'Zu groß (höchstens {mb} MB).',
    atKm: 'bei km {km}',
    video: 'Video',
    open: 'Foto {n} von {total} öffnen',
    close: 'Schließen',
    prev: 'Vorheriges',
    next: 'Nächstes',
    caption: 'Bildunterschrift',
    captionPlaceholder: 'Bildunterschrift hinzufügen',
    save: 'Speichern',
    hide: 'Ausblenden',
    show: 'Einblenden',
    remove: 'Löschen',
    removeConfirm: 'Dieses Foto endgültig löschen?',
    hiddenCount: { one: '{count} ausgeblendet', other: '{count} ausgeblendet' },
    showHidden: 'zeigen',
    hideHidden: 'verbergen',
    fromStrava: 'aus Strava',
    onMap: 'Foto auf der Karte',
    empty: 'Noch keine Fotos.',
  },
  edit: {
    title: 'Titel',
    note: 'Notiz',
    notePlaceholder: 'Wie lief es?',
    saving: 'Speichert …',
    save: 'Speichern',
    cancel: 'Abbrechen',
    hint: 'Eigene Texte gehen jeder Quelle vor und bleiben beim Neuaufbau erhalten.',
  },
  tags: {
    group: 'Markierungen',
    name: {
      Race: 'Wettkampf',
      DNF: 'Abgebrochen',
      'Long Run': 'Langer Lauf',
      Commute: 'Pendeln',
      'With Kid': 'Mit Kind',
      'With Pet': 'Mit Hund',
      Treadmill: 'Laufband',
      'For a Cause': 'Guter Zweck',
    },
    guessedDnf: 'erkannt: kürzer als {dist} – zählt nicht als Bestleistung',
    guessedRace: 'Wettkampf am Titel erkannt',
    notSaved: 'Nicht gespeichert: {error}',
    none: 'keine',
    edit: 'Ändern',
    done: 'Fertig',
  },
  rating: {
    aria: 'Bewertung',
    driftTip: 'Verhältnis {basis} zu Puls, zweite gegen erste Hälfte der Bewegungszeit',
    basisPower: 'Leistung',
    basisPace: 'Tempo',
    drift: 'Herzfrequenz-Drift',
    effTip: 'Distanz durch Herzschläge (Ø HF × Bewegungsminuten)',
    eff: 'Effizienz',
    perBeat: 'm/Schlag',
    baseline: 'Ø {sport}, 90 Tage davor: {v}',
    noBaseline: 'noch kein Vergleich – keine Einheit dieser Sportart in den 90 Tagen davor',
    aerobic: 'Aerobe Entkopplung',
    aerobicTip: 'Tempo je Puls, zweite gegen erste Hälfte der Laufzeit ab Minute 10, ohne Gehen und Stehen',
    aerobicBelow: 'unter 5 % – wohl unter der aeroben Schwelle',
    aerobicAbove: 'ab 5 % – eher über der aeroben Schwelle',
    aerobicFacts: '{min} min ab Minute 10 · Ø {hr} bpm ({first} → {second})',
    aerobicHelp: 'Lesehilfe: Unter 5 % lag der Lauf wohl unter deiner aeroben Schwelle. Das ist eine Praxisregel, keine Garantie; Hitze, Wind, Hügel und wenig Schlaf treiben die Zahl hoch.',
    aerobicTest: 'Als Drift-Test (60–75 min gleichmäßig in der oberen Hälfte von Z2): unter 5 % → Z2-Obergrenze 2–3 bpm hoch, darüber → 2–3 bpm runter.',
  },
  zones: {
    aria: 'Herzfrequenz-Zonen',
    title: 'Zeit in Zonen',
    noHr: 'Keine Herzfrequenz aufgezeichnet – die Last ist geschätzt (~).',
    noZones: 'Für diesen Tag sind keine Zonen hinterlegt.',
    foot: 'Zonen v{n} · gültig ab {date} · Ruhepuls {rest}, max. {max}',
  },
  laps: {
    title: 'Runden',
    time: 'Zeit',
    distance: 'Distanz',
    speed: 'Tempo',
    pace: 'Pace',
    hr: 'Ø HF',
    maxHr: 'Max HF',
    power: 'Ø Leistung',
    total: 'Summe',
    filter: 'Runden nach Phase',
    all: 'Alle',
    phaseHead: 'Phase',
    phase: { warmup: 'Aufwärmen', active: 'Aktiv', recovery: 'Erholung', rest: 'Pause', cooldown: 'Abkühlen' },
  },
  chart: {
    title: 'Verlauf',
    hint: 'Mausrad oder zwei Finger zum Zoomen',
    xAxis: 'x-Achse',
    distance: 'Distanz',
    time: 'Zeit',
    speed: 'Tempo',
    pace: 'Pace',
    hr: 'Herzfrequenz (bpm)',
    power: 'Leistung (W)',
    alt: 'Höhe (m)',
    summary: 'Verlauf über {axis}: {panes}',
    overDistance: 'die Distanz',
    overTime: 'die Zeit',
  },
};
